import React from 'react';
import AbstractIcon from './AbstractIcon';
var Icon = /*#__PURE__*/React.forwardRef(function (props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentcolor",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.0301097,13.4359846 L20.6547792,2.38475916 C20.9945673,1.94937144 21.6229715,1.87187266 22.0583592,2.21166079 C22.493747,2.55144892 22.5712458,3.17985311 22.2314576,3.61524084 L12.8001039,15.7001116 C12.39407,16.2203833 11.6042904,16.2115965 11.2099324,15.6824198 L8.19816766,11.6410273 C7.86815042,11.1981876 7.95961115,10.5716632 8.40245092,10.2416459 C8.8452907,9.91162868 9.4718151,10.0030894 9.80183234,10.4459292 L12.0301097,13.4359846 Z M12,0 C12.5522847,0 13,0.44771525 13,1 C13,1.55228475 12.5522847,2 12,2 C6.4771525,2 2,6.4771525 2,12 C2,17.5228475 6.4771525,22 12,22 C17.5228475,22 22,17.5228475 22,12 C22,11.4477153 22.4477153,11 23,11 C23.5522847,11 24,11.4477153 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 z"
  }));
});
var BatchstatusSettle = AbstractIcon.withComponent(Icon);
BatchstatusSettle.displayName = 'BatchstatusSettle';
export default BatchstatusSettle;